/**
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Dropdown Reverse Arrow Icon component.
 */
export const DropdownReverseArrowIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' style={{transform: 'rotate(180deg)'}}>
      <path d='M7 10l5 5 5-5z'
        fillRule='evenodd'
        clipRule='evenodd'
        fill={iconColor} />
    </svg>
  );
};
